import React from "react";
import './ImgArt.scss';
function ImgArt(props) {
  const { image, styleImg } = props;

  return (
    <div className="article-image">
      <img className= {`article-image-${styleImg}`} src={image} alt="imagen del articulo" />
    </div>
  );
}

export default ImgArt;